import { gql, TypedDocumentNode } from "@apollo/client";

export type SetJobPostFavoriteResponse = {
  setJobPostFavorite: {
    success: boolean;
    message: string | null;
    jobPost: {
      id: string;
      isFavorited: boolean;
    } | null;
  };
};

export type SetJobPostFavoriteVariables = {
  jobPostId: string;
  favorited: boolean;
};

export const SET_JOB_POST_FAVORITE_MUTATION: TypedDocumentNode<
  SetJobPostFavoriteResponse,
  SetJobPostFavoriteVariables
> = gql`
  mutation SetJobPostFavorite($jobPostId: ID!, $favorited: Boolean!) {
    setJobPostFavorite(jobPostId: $jobPostId, favorited: $favorited) {
      success
      message
      jobPost {
        id
        isFavorited
      }
    }
  }
`;
